import * as React from 'react'
import ErrorPage from '@App/components/pages/ErrorPage'
import PageLayout from '@App/components/layouts/PageLayout'
import * as Sentry from '@sentry/browser'

export interface State {
  error: Error | null,
  info: {
    componentStack?: string,
  }
  eventId: any
}

export interface Props {
  children: any
}

class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = { error: null, info: {}, eventId: null }
  }

  componentDidCatch(error: Error | null, info: object) {
    Sentry.withScope((scope) => {
      scope.setExtras(info)
      const eventId = Sentry.captureException(error)
      this.setState({ eventId })
    })

    this.setState({ info, error: error || new Error('Error') })
  }

  render() {
    const {
      info: {
        componentStack,
      },
      error,
    } = this.state
    const { children } = this.props

    if (error) {
      return (
        <PageLayout>
          <ErrorPage>
            {process.env.NODE_ENV !== 'production'
              && (
                <div style={{ color: 'red' }}>
                  <h3>
                    {error.toString()}
                  </h3>
                  <pre>
                    {componentStack}
                  </pre>
                </div>
              )
            }
          </ErrorPage>
        </PageLayout>
      )
    }

    return children
  }
}

export default ErrorBoundary
